import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, catchError, map, shareReplay, finalize } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuxiliarService {

  app: string = "https://pesaje.retsl.com";
  api: string = "https://api.retsl.com";
  socket: string = "https://socket.retsl.com";

  private cachedSocketUrl: string | null = null;
  private loadRequest$: Observable<string> | null = null;

  constructor(private httpClient: HttpClient) { }

  getServidor() {
    return this.api;
  }

  getSocket(): string {
    return this.cachedSocketUrl || this.socket;
  }

  getDefaultSocket(): string {
    return this.socket;
  }

  loadSocketUrl(): Observable<string> {
    if (this.cachedSocketUrl) {
      return of(this.cachedSocketUrl);
    }

    if (!this.loadRequest$) {
      this.loadRequest$ = this.httpClient.get<{ status: string; socketurl: string }>(
        `${this.api}/api/settings/socketurl`,
      ).pipe(
        map((result) => {
          const url = (result?.socketurl || '').trim();
          this.cachedSocketUrl = url || this.socket;
          return this.cachedSocketUrl;
        }),
        catchError(() => {
          this.cachedSocketUrl = this.socket;
          return of(this.cachedSocketUrl);
        }),
        finalize(() => {
          this.loadRequest$ = null;
        }),
        shareReplay(1),
      );
    }

    return this.loadRequest$;
  }

  ensureSocketUrlLoaded(): Promise<string> {
    return new Promise((resolve) => {
      this.loadSocketUrl().subscribe((url) => resolve(url));
    });
  }

  setSocketUrl(url: string): Observable<string> {
    const clean = url.trim().replace(/\/+$/, '');
    return this.httpClient.post<{ status: string; socketurl: string }>(
      `${this.api}/api/settings/socketurl`,
      { socketurl: clean },
    ).pipe(
      map((result) => {
        const saved = (result?.socketurl || clean).trim();
        this.cachedSocketUrl = saved || this.socket;
        return this.cachedSocketUrl;
      }),
    );
  }

  resetSocketUrl(): Observable<string> {
    return this.setSocketUrl(this.socket);
  }

  getRoot(){
    return this.app;
  }

}
